module.exports = __webpack_public_path__ + "img/space-animation.082f1905.gif";